import React, { useEffect, useState } from "react";
import { Container, Card, Spinner, Row, Col } from "react-bootstrap";
import { db } from "../firebase";
import { collection, query, where, orderBy, getDocs } from "firebase/firestore";

const NewsFeed = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const qn = query(
          collection(db, "news"),
          where("published", "==", true),
          orderBy("createdAt", "desc")
        );
        const snap = await getDocs(qn);
        setList(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <Container className="py-4">
      <h1 className="mb-4">Noticias</h1>
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : list.length === 0 ? (
        <p className="text-muted">Sin noticias por el momento.</p>
      ) : (
        <Row className="g-3">
          {list.map((n) => (
            <Col key={n.id} md={6} lg={4} id={n.id}>
              <Card className="h-100">
                {n.imageUrl && (
                  <Card.Img variant="top" src={n.imageUrl} alt={n.title} style={{ maxHeight: 160, objectFit: "cover" }} />
                )}
                <Card.Body>
                  <Card.Title>{n.title}</Card.Title>
                  <Card.Subtitle className="text-muted mb-2" style={{ fontSize: 12 }}>
                    {n.createdAt?.toDate ? n.createdAt.toDate().toLocaleDateString("es-ES") : ""}
                  </Card.Subtitle>
                  <Card.Text>{n.summary || n.body?.slice(0, 160) + "…"}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default NewsFeed;

